export const pins = {
  1903: require("@/assets/img/history/pins/1903.png"),
  1908: require("@/assets/img/history/pins/1908.png"),
  1960: require("@/assets/img/history/pins/1960.png"),
  1967: require("@/assets/img/history/pins/1967.png"),
  1977: require("@/assets/img/history/pins/1977.png"),
  1978: require("@/assets/img/history/pins/1978.png"),
  1994: require("@/assets/img/history/pins/1994.png"),
  2000: require("@/assets/img/history/pins/2000.png"),
  2019: require("@/assets/img/history/pins/2019.png"),
  2020: require("@/assets/img/history/pins/2020.png"),
};

export const slide = {
  "00/background": require("@/assets/img/history/00/background.png"),
  "00/brush": require("@/assets/img/history/00/brush.svg"),
  "00/dots": require("@/assets/img/history/00/dots.svg"),
  "00/label": require("@/assets/img/history/00/label.png"),
  "01/background": require("@/assets/img/history/01/background.jpg"),
  "01/brush": require("@/assets/img/history/01/brush.svg"),
  "01/dots": require("@/assets/img/history/01/dots.svg"),
  "01/label": require("@/assets/img/history/01/label.jpg"),
  "02/background": require("@/assets/img/history/02/background.jpg"),
  "02/brush": require("@/assets/img/history/02/brush.svg"),
  "02/dots": require("@/assets/img/history/02/dots.svg"),
  "02/label": require("@/assets/img/history/02/label.jpg"),
  "03/background": require("@/assets/img/history/03/background.jpg"),
  "03/brush": require("@/assets/img/history/03/brush.svg"),
  "03/dots": require("@/assets/img/history/03/dots.svg"),
  "03/label": require("@/assets/img/history/03/label.png"),
  "04/background": require("@/assets/img/history/04/background.png"),
  "04/brush": require("@/assets/img/history/04/brush.svg"),
  "04/dots": require("@/assets/img/history/04/dots.svg"),
  "04/label": require("@/assets/img/history/04/label.jpg"),
};
